import { type DefaultError, useQuery } from "@tanstack/react-query";

import { creatorOptionsKeys } from "@/hooks/queryKeys.ts";
import apiClient from "@/lib/api/client.ts";

interface GetCreatorOptionsResponse {
  creators: Array<{
    id: number;
    name: string;
    role?: string;
  }>;
  success: boolean;
}

export function useGetCreatorOptions(requestId?: number) {
  return useQuery<
    GetCreatorOptionsResponse,
    DefaultError,
    Array<{ id: number; role?: string; textValue: string }>
  >({
    enabled: !!requestId,
    queryFn: async () =>
      await apiClient
        .url(`/requests/list/creator-options/${requestId}`)
        .get()
        .json(),
    queryKey: creatorOptionsKeys.byRequestId(requestId),
    select: (data) =>
      data.creators.map(({ id, name, role }) => ({
        id,
        role,
        textValue: name,
      })),
  });
}
